import styled from 'styled-components';
import { MenuListStyle } from '../MenuList';
import { MenuItemStyle } from '../MenuItem';
import { showHide, showAboveBackDrop } from '../../../utils';
import { MENU_ITEM_SIZE } from '../constants';
const MenuInlineStyle = styled(MenuListStyle) `
  position: relative;

  & > ${MenuItemStyle} {
    height: ${MENU_ITEM_SIZE}px;
  }

  ${showAboveBackDrop()}
  ${showHide()}
`;
export default MenuInlineStyle;
//# sourceMappingURL=MenuInlineStyle.js.map